import { app } from '../../../../app';
import { Controller } from './security-scan.controller';

app.component('companySharingCenterSecurityScan', {
    bindings: {
        accounts: '<',
    },
    controller: Controller,
    templateUrl: require('./security-scan.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/security-scan/security-scan.component.js